import React, { useCallback, useState } from "react";
import { Container, Grid, Modal, Header } from "semantic-ui-react";
import { Formik, Field } from "formik";
import { Input, Form, TextArea } from "formik-semantic-ui-react";
import { useIntl, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { lowerFirst } from "lodash";
import SemanticFormikJsonEditor from "shared/components/forms/SemanticFormikJsonEditor";

import ActionButtons from "./ActionButtons";

const MapCardElement = ({
  button,
  onChange,
  initialValue,
  validationSchema
}) => {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = resetForm => {
    resetForm();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onSubmit = useCallback(values => {
    onChange(values);
    handleClose();
  }, []);

  return (
    <Formik
      onSubmit={onSubmit}
      enableReinitialize
      initialValues={initialValue}
      validationSchema={validationSchema}
    >
      {({ values, submitForm, resetForm }) => (
        <Modal
          open={isOpen}
          onOpen={() => handleOpen(resetForm)}
          onClose={handleClose}
          trigger={button}
          closeIcon
        >
          <Modal.Header>
            <FormattedMessage
              id={`configuratorDesign.dashboard.${lowerFirst(
                initialValue.type
              )}.type`}
            />
          </Modal.Header>
          <Modal.Content>
            <Container style={{ width: "100%" }}>
              <Form id="accountRolesBackendForm">
                <Grid style={{ width: "100%" }}>
                  <Grid.Column width={16}>
                    <Input
                      name="params.title"
                      label={useIntl().formatMessage({
                        id: "configuratorDesign.dialog.contentPageEditor.title"
                      })}
                    />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <Input
                      fluid
                      name="params.address"
                      label={useIntl().formatMessage({
                        id:
                          "configuratorDesign.dialog.contentPageEditor.address"
                      })}
                      disabled={
                        values?.params?.coords?.lat?.length > 0 ||
                        values?.params?.coords?.lang?.length > 0
                      }
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Input
                      fluid
                      name="params.coords.lat"
                      label={useIntl().formatMessage({
                        id:
                          "configuratorDesign.dialog.contentPageEditor.latitude"
                      })}
                      type="number"
                      disabled={values?.params?.address?.length > 0}
                      errorPrompt
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Input
                      fluid
                      name="params.coords.lang"
                      label={useIntl().formatMessage({
                        id:
                          "configuratorDesign.dialog.contentPageEditor.longitude"
                      })}
                      type="number"
                      disabled={values?.params?.address?.length > 0}
                      errorPrompt
                    />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <TextArea
                      fluid
                      errorPrompt={{
                        prompt: false,
                        pointing: false
                      }}
                      name="params.description"
                      label={useIntl().formatMessage({
                        id:
                          "configuratorDesign.dialog.contentPageEditor.description"
                      })}
                    />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <Header as="h4" style={{ marginBottom: 10 }}>
                      {useIntl().formatMessage({
                        id:
                          "configuratorDesign.dialog.contentPageEditor.presentation"
                      })}
                    </Header>
                    <Field
                      id="css"
                      name="css"
                      label={useIntl().formatMessage({
                        id: "configuratorDesign.dialog.contentPageEditor.css"
                      })}
                      component={SemanticFormikJsonEditor}
                    />
                  </Grid.Column>
                </Grid>
              </Form>
            </Container>
          </Modal.Content>
          <Modal.Actions>
            <ActionButtons onClose={handleClose} onSubmit={submitForm} />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

MapCardElement.propTypes = {
  button: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({
    type: PropTypes.string.isRequired,
    params: PropTypes.shape({
      title: PropTypes.string,
      address: PropTypes.string,
      coords: PropTypes.shape({
        lat: PropTypes.number,
        lang: PropTypes.number
      }),
      description: PropTypes.string
    })
  }),
  // eslint-disable-next-line react/forbid-prop-types
  validationSchema: PropTypes.object.isRequired
};

MapCardElement.defaultProps = {
  initialValue: {
    params: {
      title: "",
      address: "",
      coords: {
        lat: null,
        lang: null
      },
      description: ""
    }
  }
};

export default MapCardElement;
